// extracted by mini-css-extract-plugin
export default {"destinations":"style_destinations__ca85f","grid":"style_grid__MnKFQ","big":"style_big__mgciy","small":"style_small__NgYEg"};